var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "aptitude",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffecb3",
    d: "M42 17c0-5.899-5.107-10.604-11.141-9.937-4.622.511-8.358 4.304-8.81 8.933a9.97 9.97 0 0 0 3.521 8.652A3.994 3.994 0 0 1 27 27.705V31h10v-3.295c0-1.169.505-2.286 1.403-3.034A9.962 9.962 0 0 0 42 17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8088",
    d: "m32 11 1.545 3.292L37 14.82l-2.5 2.562.59 3.618L32 19.292 28.91 21l.59-3.618L27 14.82l3.455-.528z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#495766",
    d: "M28 31a3 3 0 0 0 3 3h2a3 3 0 0 0 3-3h-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#526273",
    d: "M27 28h10v3H27z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d90bf",
    d: "m56 29-6 7h3v26h6V36h3zM44 38l-6 7h3v17h6V45h3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffecb3",
    d: "M31 1h2v3h-2zM45 16h3v2h-3zM16 16h3v2h-3zM40.485 26.9l1.414-1.415 2.122 2.122-1.414 1.414zM19.98 6.393l1.413-1.414 2.122 2.122L22.1 8.515zM40.485 7.1l2.12-2.12 1.415 1.414L41.9 8.515zM19.98 27.607l2.12-2.122 1.415 1.414-2.122 2.122z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#759acc",
    d: "M19 58V46c0-3.31-2.69-6-6-6H9c-3.31 0-6 2.69-6 6v12h16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#526273",
    d: "M33 55v-4h-1.262a7.968 7.968 0 0 0-.852-2.058l.892-.892-2.828-2.828-.892.892A7.953 7.953 0 0 0 26 45.262V44h-4v1.262a7.968 7.968 0 0 0-2.058.852l-.892-.892-2.828 2.828.892.892A7.953 7.953 0 0 0 16.262 51H15v4h1.262c.189.732.477 1.422.852 2.058l-.892.892 2.828 2.828.892-.892a7.953 7.953 0 0 0 2.058.852V62h4v-1.262a7.968 7.968 0 0 0 2.058-.852l.892.892 2.828-2.828-.892-.892A7.939 7.939 0 0 0 31.738 55H33zm-9 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "m11 40-2 9 2 3 2-3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 34,
    r: 6,
    fill: "#ffdbac"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#526273",
    d: "M11 28a6 6 0 0 0-6 6c0 .075.008.147.011.221l.029-.051C6.5 32.53 8.63 31.5 11 31.5s4.5 1.03 5.96 2.67a.476.476 0 0 0 .03.018c.002-.063.01-.124.01-.188a6 6 0 0 0-6-6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.15c749a38de81c6c1c758bc58807f649.svg";
export { ForwardRef as ReactComponent };